import { render } from "./Ticket_Conversation.vue?vue&type=template&id=40837575"
import script from "./Ticket_Conversation.vue?vue&type=script&lang=js"
export * from "./Ticket_Conversation.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__